<template>
  <a-select
    ref="selectEl"
    v-model="value"
    :mode="mode"
    :showArrow="true"
    :show-search="searchable"
    :allowClear="allowClear"
    :defaultOpen="defaultOpen"
    :placeholder="placeholder"
    option-label-prop="label"
    :dropdownMatchSelectWidth="false"
    :filter-option="filterOption"
    optionFilterProp="label"
    :disabled="disabled"
    @change="onChange"
    @select="onSelect"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    :getPopupContainer="
      triggerNode => {
        return triggerNode.parentNode || document.body
      }
    "
    :class="[$attrs.bg && $attrs.bg === 'white' ? `light` : ``]"
  >
    <template v-if="optionType.group">
      <a-select-opt-group v-for="group in groups" :key="group" class="">
        <template #label>
          <span class="flex items-center truncate">
            <base-icon :icon="selectIcon['icon']" :class="selectIcon['class']" />
            {{ group }}
          </span>
        </template>
        <a-select-option
          v-for="option in optionsList(group)"
          :key="option[optionType.id]"
          :label="`${translateLabel(option[optionType.label])}`"
        >
          <span v-html="selectLabel(option)"></span>
        </a-select-option>
      </a-select-opt-group>
    </template>
    <template v-else>
      <a-select-option
        v-for="option in options"
        v-show="option.group === group"
        :key="option[optionType.id]"
        :label="`${translateLabel(option[optionType.label])}`"
        :disabled="option.disabled"
      >
        <span v-html="selectLabel(option)"></span>
      </a-select-option>
    </template>
  </a-select>
</template>

<script>
import Select from 'ant-design-vue/lib/select'
import Input from 'ant-design-vue/lib/input' // for js
import 'ant-design-vue/lib/select/style/index.css'
import BaseIcon from './_base-icon.vue'
import Tablet from '../icons/tablet.vue'

export default {
  inheritAttrs: false,
  components: {
    [Select.name]: Select,
    'a-select-option': Select.Option,
    'a-input': Input,
    'a-select-opt-group': Select.OptGroup,
    BaseIcon,
  },
  props: {
    value: {
      type: [Number, String, Array],
    },
    options: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: [Number, String, Array],
    },
    mode: {
      type: String,
      default: 'default',
    },
    placeholder: {
      type: String,
      default: '',
    },
    filterOption: {
      default: true,
    },
    onSelect: {
      type: Function,
      required: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    optionType: {
      type: Object,
      default: () => {
        return {
          id: 'id',
          label: 'label',
        }
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  model: {
    event: 'update',
  },
  computed: {
    groups() {
      const groupList = new Set()
      this.options?.forEach(element => {
        groupList.add(element[this.optionType.group])
      })
      return groupList
    },
    selectIcon() {
      return {
        icon: this.optionType.group === 'company_name' ? 'company' : 'arrow-down',
        class: this.optionType.group === 'company_name' ? 'pr-2' : '',
      }
    },
  },
  methods: {
    onChange(value) {
      this.$emit('update', this.value)
    },
    selectLabel(option) {
      let info = ''
      if (this.optionType.extra) {
        const values = this.optionType.extra?.map(k => option[k]) || ''
        info = values.join('-')
      }
      // if (Array.isArray(info)) {
      //   info = info.toString().replace(',', '-')
      // }

      return `<div class="flex items-center justify-between"><span>${this.translateLabel(
        option[this.optionType.label]
      )}</span><span class="ml-4 opacity-50">${info}</div>`
    },
    translateLabel(label) {
      return this.$te(`mygwf.components.Label.${label}`)
        ? this.$t(`mygwf.components.Label.${label}`)
        : label
    },
    optionsList(group) {
      return this.options.filter(option => option[this.optionType.group] === group)
    },
    focus() {
      this.$refs.selectEl.focus()
    },
    blur() {
      this.$refs.selectEl.blur()
    },
    getSelected() {
      return this.value
    },
  },
}
</script>

<style>
.ant-select {
  font-size: inherit !important;
  width: 100%;
}

.ant-select-selection {
  @apply bg-secondary-light appearance-none inline-block w-full border border-gray-200 rounded-none leading-normal cursor-default;
}
.ant-select-selection:hover {
  @apply border-gray-200;
}
.light .ant-select-selection {
  @apply bg-white;
}

.ant-select-focused .ant-select-selection {
  @apply outline-none border-primary-light bg-white;
}
.ant-select-dropdown-menu-item-group-title {
  @apply border-b border-secondary;
}

.ant-select-selection:disabled {
  @apply opacity-50 bg-secondary border-gray-300 cursor-default;
}
.ant-select-selection__clear {
  background: transparent !important;
  margin-top: -9px !important;
  color: rgba(50, 50, 50, 1) !important;
  font-size: 13px !important;
}
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  box-shadow: none;
  outline: 0;
}
.ant-select-selection__choice__content {
  font-size: 0.85rem;
}
.ant-select-dropdown-menu-item {
  font-size: inherit !important;
}
</style>
